// extracted by mini-css-extract-plugin
module.exports = {"form":"ProviderEditForm_form__1SQHq","submitBtn":"ProviderEditForm_submitBtn__1vpSt"};